<div class="position-fixed h-100 w-100">
    <app-ol-map class="map" [center]="[11.1228, 46.0661]" [zoom]="10" (mapReady)="onMapReady($event)"></app-ol-map>
</div>
